import { useEffect, useState } from "react"
import {
  StoryblokComponent,
  useStoryblokState,
  getStoryblokApi,
  ISbStoryData,
} from "@storyblok/react"
import { useParams } from "react-router-dom"

function BlogPostPage() {
  const { slug } = useParams()
  const [story, setStory] = useState<ISbStoryData | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      const sbApi = getStoryblokApi()
      try {
        const { data } = await sbApi.get(`cdn/stories/blog/${slug}`, {
          version: "draft",
        })
        setStory(data?.story)
      } catch (error) {
        console.error("Failed to load blog post:", error)
      }
    }

    if (slug) {
      fetchData()
    }
  }, [slug])

  const liveStory = useStoryblokState(story as ISbStoryData)

  if (!liveStory || !liveStory.content) return <div></div>

  return <StoryblokComponent blok={liveStory.content} />
}

export default BlogPostPage
